import React from 'react';
import { Logs } from '../views/developers/Logs';
import { ReportsPage } from '../views/reports/ReportsPage';
import { ActivityLogPage } from '../views/activity-log/ActivityLogPage';
import { PageLink } from '../layout/core';
import { ApiClients } from '../views/api-clients/ApiClients';
// import { FeeConfiguration } from '../views/default-fee/FeeConfiguration';
import { Provider } from '../views/provider/Provider';
import { Transactions } from '../views/transactions/Transactions';
import { CustomKeyDetails } from '../components/api-clients/CustomKeyDetails';
import { AuditLogs } from '../views/audit-logs/AuditLogs';
import { DisputesAlertProvidersList } from '../views/disputes-alert-provider/DisputesAlertProvidersList';

const BASE_URL = '/admin';

export enum ADMIN_ROUTES {
  WEBHOOK_ACTIVITY = 'webhooks-activity',
  TRANSACTIONS = 'transactions',
  ACTIVITY_LOG = 'activity-log',
  REPORTS = 'reports',
  PROVIDER = 'providers',
  DISPUTES_ALERT_PROVIDERS = 'alert-providers',
  FEE_CONFIGURATION = 'fee-configuration',
  API_CLIENTS = 'api-clients',
  AUDIT_LOGS = 'audit-logs',
}

export const adminBreadCrumbs: Array<PageLink> = [
  {
    title: 'MENU.ADMIN',
    path: `${BASE_URL}/${ADMIN_ROUTES.WEBHOOK_ACTIVITY}`,
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
];
export const apiClientBreadCrumbs: Array<PageLink> = [
  {
    title: 'MENU.API_CLIENTS',
    path: `${BASE_URL}/${ADMIN_ROUTES.API_CLIENTS}`,
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
];

export const adminRoutes = [
  {
    key: ADMIN_ROUTES.WEBHOOK_ACTIVITY,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.WEBHOOK_ACTIVITY}`,
    title: 'MENU.WEBHOOKS_ACTIVITY',
    component: <Logs/>,
    breadcrumbs: adminBreadCrumbs,
  },
  {
    key: ADMIN_ROUTES.TRANSACTIONS,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.TRANSACTIONS}`,
    title: 'MENU.TRANSACTIONS',
    component: <Transactions/>,
    breadcrumbs: adminBreadCrumbs,
  },
  {
    key: ADMIN_ROUTES.ACTIVITY_LOG,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.ACTIVITY_LOG}`,
    title: 'MENU.ACTIVITY_LOG',
    component: <ActivityLogPage/>,
    breadcrumbs: adminBreadCrumbs,
  },
  {
    key: ADMIN_ROUTES.REPORTS,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.REPORTS}`,
    title: 'MENU.REPORTS',
    component: <ReportsPage/>,
    breadcrumbs: adminBreadCrumbs,
  },
  // {
  //   key: ADMIN_ROUTES.PROVIDER,
  //   pathname: `${BASE_URL}/${ADMIN_ROUTES.PROVIDER}`,
  //   title: 'MENU.PROVIDER',
  //   component: <Provider/>,
  //   breadcrumbs: adminBreadCrumbs,
  // },
  {
    key: ADMIN_ROUTES.DISPUTES_ALERT_PROVIDERS,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.DISPUTES_ALERT_PROVIDERS}`,
    title: 'MENU.DISPUTES_ALERT_PROVIDERS',
    component: <DisputesAlertProvidersList/>,
    breadcrumbs: adminBreadCrumbs,
  },
  // {
  //   key: ADMIN_ROUTES.FEE_CONFIGURATION,
  //   pathname: `${BASE_URL}/${ADMIN_ROUTES.FEE_CONFIGURATION}`,
  //   title: 'MENU.FEE_CONFIGURATION',
  //   component: <FeeConfiguration/>,
  //   breadcrumbs: adminBreadCrumbs,
  // },
  {
    key: ADMIN_ROUTES.API_CLIENTS,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.API_CLIENTS}`,
    title: 'MENU.API_CLIENTS',
    component: <ApiClients/>,
    breadcrumbs: adminBreadCrumbs,
  },
  {
    key: `${ADMIN_ROUTES.API_CLIENTS}-id`,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.API_CLIENTS}/:clientId`,
    title: 'MENU.API_CLIENTS',
    component: <CustomKeyDetails/>,
    breadcrumbs: apiClientBreadCrumbs,
  },
  {
    key: `${ADMIN_ROUTES.AUDIT_LOGS}-id`,
    pathname: `${BASE_URL}/${ADMIN_ROUTES.AUDIT_LOGS}`,
    title: 'MENU.AUDIT_LOGS',
    component: <AuditLogs/>,
    breadcrumbs: apiClientBreadCrumbs,
  },
];
